/**
 * The access token lives in module memory and nowhere else — not in localStorage,
 * not in a readable cookie — so script injected into the page has no store to steal
 * from. The price is a refresh round-trip on every full page load, which the silent
 * refresh in AuthProvider pays automatically.
 */
let accessToken: string | null = null

/**
 * Whose session the token is. Set with the token, in the same breath, so work that must
 * not cross from one account to another — a batch of uploads another tab's sign-in could
 * otherwise finish under somebody else (Copilot on #66) — can ask at the instant it reads
 * the token, before React has heard of the change.
 */
let tokenOwner: string | null = null

export function setAccessToken(token: string | null, owner: string | null = null): void {
  accessToken = token
  tokenOwner = token === null ? null : owner
}

/**
 * Headers for authenticated calls, passed through the `init` parameter of lib/api
 * (whose header merge keeps Content-Type intact). Read at call time, so a request
 * fired after a silent refresh picks up the fresh token.
 */
export function withAuth(): HeadersInit {
  return accessToken === null ? {} : { Authorization: `Bearer ${accessToken}` }
}

/** The user the token in use was issued to; null with no session. */
export function sessionOwner(): string | null {
  return tokenOwner
}
